import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Buttons extends Component {

	render() {

		return (
			<div id="lscore-buttons">
				<SelectYear
					onYearChange={this.props.onYearChange}
					year={this.props.year}
				/>
				<button
					onClick={this.props.onReset}
				>
					Reset
				</button>
				<button
					onClick={this.props.onRandomize}
				>
					Random
				</button>
				<button
					onClick={this.props.onReverse}
				>
					Reverse
				</button>
			</div>
		)
	}
}

Buttons.propTypes = {
	teams: PropTypes.object,
	order: PropTypes.array,
}

class SelectYear extends Component {
	render() {
		if (!this.props.year) {
			return null
		}

		const minYear = 2012		// First year with 18 teams

		const d = new Date()
		let maxYear = d.getFullYear()
		const month = d.getMonth()

		if (month >= 9) {
			maxYear += 1
		}

		const okYears = [ ]

		for (let yr = maxYear; yr >= minYear; yr -= 1) {
			okYears.push(yr)
		}

		return (
			<select onChange={this.props.onYearChange} defaultValue={this.props.year}>
				{
					okYears.map( yr => <option key={yr}>{yr}</option>)
				}
			</select>
		)
	}
}

export default Buttons
